import './style.css';
import Application from './Application/Application';

new Application();
